import {
    createApp,
} from 'vue';
import Routes from './routes';
import TemplateRoutes from './components/TemplateRoutes.vue';
import TemplateLogin from './components/TemplateLogin.vue';
import { localization } from './l10n';
import vuetify from './plugins/vuetify';
import 'vuetify/styles';
import loadFonts from './plugins/webfontloader';

if (Array.prototype.at == null) {
    // eslint-disable-next-line no-inner-declarations
    function at(pn) {
        let n = Math.trunc(pn) || 0;
        if (n < 0) n += this.length;
        if (n < 0 || n >= this.length) return undefined;
        return this[n];
    }

    const TypedArray = Reflect.getPrototypeOf(Int8Array);
    for (const C of [Array, String, TypedArray]) {
        Object.defineProperty(
            C.prototype,
            'at',
            {
                value: at,
                writable: true,
                enumerable: false,
                configurable: true,
            },
        );
    }
}

loadFonts();

export default function startup(el, routes, authorization) {
    if (routes.login == null) {
        routes.login = TemplateLogin;
    }

    const app = createApp(TemplateRoutes);
    app.use(vuetify);
    app.use(new Routes(routes));
    app.use(localization);
    app.use(authorization);
    authorization.initialize(true)
        .finally(() => {
            app.mount(el);
        });
    return app;
}
